"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToScheduledChangeStatus = exports.DeleteScheduledKeywordChangeRequestSchema = exports.DeleteScheduledKeywordAssignmentsChangeRequestSchema = exports.DeleteScheduledRegionChangeRequestSchema = exports.DeleteScheduledChannelChangeRequestSchema = exports.UpdateScheduledKeywordAssignmentsChangeBodySchema = exports.UpdateScheduledKeywordAssignmentsChangeSchema = exports.ScheduledKeywordAssignmentsChangeRequestSchema = exports.ScheduledKeywordAssignmentsChangeBodySchema = exports.UpdateScheduledKeywordChangeBodySchema = exports.UpdateScheduledKeywordChangeSchema = exports.ScheduledKeywordChangeRequestSchema = exports.ScheduledKeywordChangeBodySchema = exports.UpdateScheduledRegionChangeRequestSchema = exports.UpdateScheduledChannelChangeRequestSchema = exports.UpdateScheduledRegionChangeBodySchema = exports.UpdateScheduledChannelChangeBodySchema = exports.CreateScheduledRegionChangeBodySchema = exports.CreateScheduledChannelChangeBodySchema = exports.ScheduledRegionChangeResponseSchema = exports.ScheduledChannelChangeResponseSchema = exports.ScheduledKeywordAssignmentsChangeResponseSchema = exports.ScheduledKeywordAssignmentsChangeSchema = exports.ScheduledKeywordChangeResponseSchema = exports.ScheduledKeywordChangeSchema = exports.ScheduledRegionChangeSchema = exports.ScheduledChannelChangeSchema = exports.ListScheduledChangesQuerySchema = exports.ScheduledChangeStatusSchema = exports.ScheduledChangeStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const utils_1 = require("../../../utils");
const asr_1 = require("./asr");
var ScheduledChangeStatus;
(function (ScheduledChangeStatus) {
    ScheduledChangeStatus["ACTIVE"] = "ACTIVE";
    ScheduledChangeStatus["DELETED"] = "DELETED";
    ScheduledChangeStatus["COMPLETED"] = "COMPLETED";
})(ScheduledChangeStatus = exports.ScheduledChangeStatus || (exports.ScheduledChangeStatus = {}));
exports.ScheduledChangeStatusSchema = (0, core_1.StringUnion)([
    ScheduledChangeStatus.ACTIVE,
    ScheduledChangeStatus.DELETED,
    ScheduledChangeStatus.COMPLETED,
]);
exports.ListScheduledChangesQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({
    changeStatus: typebox_1.Type.Array(exports.ScheduledChangeStatusSchema),
    ...core_1.DateFilterFields,
});
exports.ScheduledChannelChangeSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    createdAt: typebox_1.Type.Number(),
    updatedAt: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    changeStatus: exports.ScheduledChangeStatusSchema,
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateAppleSearchResultsChannelBodySchema,
});
exports.ScheduledRegionChangeSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    createdAt: typebox_1.Type.Number(),
    updatedAt: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    regionId: typebox_1.Type.Number(),
    changeStatus: exports.ScheduledChangeStatusSchema,
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateAppleSearchResultsRegionBodySchema,
});
exports.ScheduledKeywordChangeSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    createdAt: typebox_1.Type.Number(),
    updatedAt: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    keywordId: typebox_1.Type.Number(),
    changeStatus: exports.ScheduledChangeStatusSchema,
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateAppleTargetingKeywordBodySchema,
});
exports.ScheduledKeywordChangeResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ScheduledKeywordChangeSchema);
exports.ScheduledKeywordAssignmentsChangeSchema = (0, core_1.StrictObject)({
    id: typebox_1.Type.Number(),
    createdAt: typebox_1.Type.Number(),
    updatedAt: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    changeStatus: exports.ScheduledChangeStatusSchema,
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateRegionalKeywordAssignmentBodySchema,
});
exports.ScheduledKeywordAssignmentsChangeResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ScheduledKeywordAssignmentsChangeSchema);
exports.ScheduledChannelChangeResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ScheduledChannelChangeSchema);
exports.ScheduledRegionChangeResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.ScheduledRegionChangeSchema);
exports.CreateScheduledChannelChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateAppleSearchResultsChannelBodySchema,
});
exports.CreateScheduledRegionChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateAppleSearchResultsRegionBodySchema,
});
exports.UpdateScheduledChannelChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Optional(typebox_1.Type.Number()),
    targetState: typebox_1.Type.Optional(asr_1.UpdateAppleSearchResultsChannelBodySchema),
    changeStatus: typebox_1.Type.Optional(exports.ScheduledChangeStatusSchema),
});
exports.UpdateScheduledRegionChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Optional(typebox_1.Type.Number()),
    targetState: typebox_1.Type.Optional(asr_1.UpdateAppleSearchResultsRegionBodySchema),
    changeStatus: typebox_1.Type.Optional(exports.ScheduledChangeStatusSchema),
});
exports.UpdateScheduledChannelChangeRequestSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
});
exports.UpdateScheduledRegionChangeRequestSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    regionId: typebox_1.Type.Number(),
});
exports.ScheduledKeywordChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateAppleTargetingKeywordBodySchema,
    changeStatus: typebox_1.Type.Optional(exports.ScheduledChangeStatusSchema),
});
exports.ScheduledKeywordChangeRequestSchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    keywordId: typebox_1.Type.Number(),
});
exports.UpdateScheduledKeywordChangeSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    keywordId: typebox_1.Type.Number(),
});
exports.UpdateScheduledKeywordChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Optional(typebox_1.Type.Number()),
    targetState: typebox_1.Type.Optional(asr_1.UpdateAppleSearchResultsChannelBodySchema),
    changeStatus: typebox_1.Type.Optional(exports.ScheduledChangeStatusSchema),
});
exports.ScheduledKeywordAssignmentsChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Number(),
    targetState: asr_1.UpdateRegionalKeywordAssignmentBodySchema,
    changeStatus: typebox_1.Type.Optional(exports.ScheduledChangeStatusSchema),
});
exports.ScheduledKeywordAssignmentsChangeRequestSchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
});
exports.UpdateScheduledKeywordAssignmentsChangeSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
});
exports.UpdateScheduledKeywordAssignmentsChangeBodySchema = (0, core_1.StrictObject)({
    changeAt: typebox_1.Type.Optional(typebox_1.Type.Number()),
    targetState: typebox_1.Type.Optional(asr_1.UpdateAppleSearchResultsChannelBodySchema),
    changeStatus: typebox_1.Type.Optional(exports.ScheduledChangeStatusSchema),
});
exports.DeleteScheduledChannelChangeRequestSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
});
exports.DeleteScheduledRegionChangeRequestSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
    regionId: typebox_1.Type.Number(),
});
exports.DeleteScheduledKeywordAssignmentsChangeRequestSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
});
exports.DeleteScheduledKeywordChangeRequestSchema = (0, core_1.StrictObject)({
    scheduledChangeId: typebox_1.Type.Number(),
    teamId: typebox_1.Type.Number(),
    campaignId: typebox_1.Type.Number(),
});
exports.castToScheduledChangeStatus = (0, utils_1.castToEnum)(ScheduledChangeStatus);
